<template>
    <div class="biz-section-one">
        <div v-if="isCalculate" class="landing-modal">
            <div class="modal-wrap">
                <img class="close" @click="isCalculate=false" src="@/assets/img/landingPage/bussiness/cancel.svg" alt="">
                <div class="content">
                    <div class="estimate">預估可省下</div>
                    <div class="amount">
                        {{amount?toCurrency(amount*9000):0}}
                        <span class="unit">
                            元
                        </span>
                    </div>
                    <button class="switch-btn btn-blue" @click="$router.push({name: 'bizLogin'})">我想提升效率</button>
                </div>
            </div>
        </div>
        <div class="landing-container wrap">
            <div class="calculator" >
                <div class="input-block">
                    <input type="text" v-model="amount" placeholder="請輸入您的房源數量">
                    <span class="calculate-btn" @click="caculate">
                        開始計算
                    </span>
                </div>
                <div v-if="isCalculate" @mouseleave="isCalculate=false" class="calculate-result">
                    <div class="estimate">預估可省下</div>
                    <div class="amount">
                        {{amount?toCurrency(amount*9000):0}}
                        <span class="unit">
                            元
                        </span>
                    </div>
                    <button class="switch-btn btn-blue" @click="$router.push({name: 'bizLogin'})">我想提升效率</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return{
            amount: null,
            isCalculate: false
        }
    },
    methods: {
        caculate: function () {
            this.isCalculate = true
        }
    },
    watch: {
        amount: function (val) {
            this.$store.dispatch('setHouseAmount', val);
        },
    }
}
</script>
<style lang="scss" scoped>
    .biz-section-one{
        position: relative;
        background-color:#ffece3;
        display: flex;
        justify-content: center;
        height: 463px;
        z-index: 2;
        .landing-modal{
            display: none;
        }
        .wrap{
            position: relative;
            width: 1100px;
            background-repeat: no-repeat;
            background: url('../../../assets/img/landingPage/bussiness/section_one_bg.png');
            background-size: 1100px;
            .calculator{
                position: absolute;
                top: 242px;
                left: 98px;
                .input-block{
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 511px;
                    height: 88px;
                    box-sizing: border-box;
                    border-radius: 16px;
                    box-shadow: 4px 8px 15px 0 rgba(60, 60, 61, 0.2);
                    background-color: #ffffff;
                    padding: 8px 30px;
                    z-index: 2;
                    input {
                        border: none;
                        width: 300px;
                        height: 78px;
                        font-size: 26px;
                        &::placeholder {
                            /* Chrome, Firefox, Opera, Safari 10.1+ */
                            color:#b4b4b4;
                            letter-spacing: 0.44px;
                            font-size: 24px;
                        }
                        &:-ms-input-placeholder {
                            /* Internet Explorer 10-11 */
                            color: #b4b4b4;
                            letter-spacing: 0.44px;
                            font-size: 24px;
                        }
                        
                        &::-ms-input-placeholder {
                            /* Microsoft Edge */
                            color: #b4b4b4;
                            letter-spacing: 0.44px;
                            font-size: 24px;
                        }
                    }
                    .calculate-btn{
                        font-size: 22px;
                        font-weight: 500;
                        color: #36b0ff;
                        cursor: pointer;
                        
                    }
                }
                
                .calculate-result{
                    position: absolute;
                    width: 511px;
                    height: 372px;
                    border-radius: 16px;
                    box-shadow: 9px 8px 15px 0 rgba(155, 154, 154, 0.3);
                    background-color: #ffffff;
                    top: 0;
                    bottom: 0;
                    z-index: 1;
                    padding: 0 30px 40px 30px;
                    box-sizing: border-box;
                    .estimate{
                        font-size: 22px;
                        line-height: 3.32;
                        letter-spacing: 0.4px;
                        color: #28292d;
                        margin-top: 100px;
                    }
                    .amount{
                        font-size: 50px;
                        font-weight: bold;
                        line-height: 1.46;
                        letter-spacing: 0.91px;
                        color: #ff4848;
                        margin-bottom: 20px;
                        .unit{
                            font-size: 26px;
                            font-weight: normal;
                            letter-spacing: 0.47px;
                            color: #28292d;
                        }
                    }
                    .switch-btn{
                        width: 100%;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1100px) {
        .biz-section-one{
            height: 412px;
            .landing-modal{
                position: fixed;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                top: 0;
                z-index: 9;
                .modal-wrap{
                    position: relative;
                    width: 325px;
                    height: 291px;
                    border-radius: 20px;
                    background-color: #ffffff;
                    .close{
                        position: absolute;
                        top: 26px;
                        right: 26px;
                        cursor: pointer;
                    }
                    .content{
                        text-align: center;
                        .estimate{
                            font-size: 22px;
                            line-height: 3.32;
                            letter-spacing: 0.4px;
                            color: #28292d;
                            margin-top: 34px;
                        }
                        .amount{
                            font-size: 36px;
                            font-weight: bold;
                            line-height: 1.46;
                            letter-spacing: 0.91px;
                            color: #ff4848;
                            margin-bottom: 40px;
                            .unit{
                                font-size: 20px;
                                font-weight: normal;
                                letter-spacing: 0.47px;
                                color: #28292d;
                            }
                        }
                        .switch-btn{
                            width: 80%;
                            font-size: 16px;
                            height: 46px;
                            border-radius: 9px;
                            margin: 0 auto;
                        }
                    }
                }
            }
            .wrap{
                position: relative;
                width: 376px;
                background-repeat: no-repeat;
                background: url('../../../assets/img/landingPage/bussiness/section_one_bg_mb.png');
                background-size: 376px;
                .calculator{
                    position: absolute;
                    top: 200px;
                    left: 15px;
                    .input-block{
                        width: 346px;
                        height: 63px;
                        padding: 8px 4px;
                        z-index: 2;
                        input {
                            border: none;
                            width: 147px;
                            height: 53px;
                            font-size: 16px;
                            &::placeholder {
                                /* Chrome, Firefox, Opera, Safari 10.1+ */
                                color:#b4b4b4;
                                letter-spacing: 0.44px;
                                font-size: 16px;
                            }
                            &:-ms-input-placeholder {
                                /* Internet Explorer 10-11 */
                                color: #b4b4b4;
                                letter-spacing: 0.44px;
                                font-size: 16px;
                            }
                            
                            &::-ms-input-placeholder {
                                /* Microsoft Edge */
                                color: #b4b4b4;
                                letter-spacing: 0.44px;
                                font-size: 16px;
                            }
                        }
                        .calculate-btn{
                            font-size: 16px;
                            margin-right: 8px;
                        }
                    }
                    
                    .calculate-result{
                        display: none;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 320px) {
         .biz-section-one{
            .landing-modal{
                .modal-wrap{
                    width: 300px;
                    height: 280px;
                }
            }
            .wrap{
                .calculator{
                   
                    .input-block{
                        width: 290px;
                        height: 63px;
                        padding: 8px 4px;
                        z-index: 2;
                        input {
                            border: none;
                            width: 147px;
                            height: 53px;
                            font-size: 16px;
                          
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/officailPage/bussiness/sectionOne.vue